// @flow
import type { FSA } from 'types/redux';
import type { Country, City, TaxiType } from 'types/country';
import _ from 'lodash';
import { GET_COUNTRIES } from 'actions/countries';
import * as RequestResultCases from 'middlewares/api-middleware';

export type CountriesState = {
  entities: Array<Country>,
  countryHash: { _?: number, _?: Country },
  cityHash: { _?: number, _?: City },
  taxiTypeHash: { _?: number, _?: TaxiType },
};

export const defaultCountriesState = {
  entities: [],
  countryHash: {},
  cityHash: {},
  taxiTypeHash: {},
};

export function createCountryHash(countries: Array<Country>) {
  const hash = {};
  for (const country of countries) {
    hash[country.countryID] = { ...country };
  }

  return hash;
}

export function createCityHash(countries: Array<Country>) {
  const cities = _.flatten(_.map(countries, 'cities'));
  const hash = {};
  for (const city of cities) {
    hash[city.cityID] = { ...city };
  }

  return hash;
}

export function createTaxiTypeHash(countries: Array<Country>) {
  const cities = _.flatten(_.map(countries, 'cities'));
  const taxiTypes = _.filter(
    _.flatten(_.map(cities, city => _.map(city.taxiTypes,
      taxiType => ({ ...taxiType, cityID: city.cityID, cityCode: city.code })))
    ),
    taxiType => (taxiType !== null));

  const hash = {};
  for (const taxiType of taxiTypes) {
    hash[taxiType.taxiTypeID] = { ...taxiType };
  }
  return hash;
}

const countries = (state: CountriesState = defaultCountriesState, action: FSA): CountriesState => {
  switch (action.type) {
    case GET_COUNTRIES + RequestResultCases.SUCCESS:
      return {
        ...state,
        entities: _.sortBy(action.payload, 'name'),
        countryHash: createCountryHash(action.payload),
        cityHash: createCityHash(action.payload),
        taxiTypeHash: createTaxiTypeHash(action.payload),
      };
    default:
      return state;
  }
};

export default countries;
